import CryptoJS from "crypto-js";

const SECRET_KEY = "fAlk3-2o25-53cr3t-k3y";

export function secureKeySend(plainText) {
  return CryptoJS.AES.encrypt(plainText, SECRET_KEY).toString();
}

export function secureKeyGet(encryptedText){
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (e) {
    console.error("Decryption failed:", e);
    return "";
  }
}
